import { useMutation } from '@tanstack/react-query';

import {
  fetchSubmitNativeLabOrderSet,
  type SubmitNativeLabOrderSetRequestT,
  type SubmitNativeLabOrderSetResponseT,
} from '../api/submitNativeLabOrderSet.js';

export interface SubmitNativeLabOrderSetVariables {
  userId: string;
  data: SubmitNativeLabOrderSetRequestT;
}

export function useSubmitNativeLabOrderSetMutation() {
  return useMutation({
    mutationKey: ['labs', 'submit-native-order-set'],
    mutationFn: async ({
      userId,
      data,
    }: SubmitNativeLabOrderSetVariables): Promise<SubmitNativeLabOrderSetResponseT> => {
      return await fetchSubmitNativeLabOrderSet(userId, data);
    },
  });
}
